export default "__VITE_ASSET__c3ac5fae__"